module.exports = "/images/circle-marker-car-7-5.png?cf2dd903cab76f0ff1b26cad5df39815";